import React, { createContext, useContext, useState } from "react";

const DialogContext = createContext<{
  openDialogs: number;
  registerDialog: () => void;
  unregisterDialog: () => void;
}>({
  openDialogs: 0,
  registerDialog: () => {},
  unregisterDialog: () => {},
});

export const DialogProvider = ({ children }: { children: React.ReactNode }) => {
  const [openDialogs, setOpenDialogs] = useState(0);

  const registerDialog = () => setOpenDialogs((prev) => prev + 1);
  const unregisterDialog = () =>
    setOpenDialogs((prev) => Math.max(prev - 1, 0));

  return (
    <DialogContext.Provider
      value={{ openDialogs, registerDialog, unregisterDialog }}
    >
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogContext = () => useContext(DialogContext);
